import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicRadioColorLabel = () => {
  return (
    <Box mb={2}>
      <PreviewAndEditor
        title={"Basic radio colors with error, label and helper text"}
        language={"js"}
        value={"        <FormControl error={true} variant=\"standard\">\n" +
            "          <FormLabel>label</FormLabel>\n" +
            "          <RadioGroup\n" +
            "            name=\"quiz\"\n" +
            "            value={\"\"}\n" +
            "          >\n" +
            "            <FormControlLabel\n" +
            "              value=\"best\"\n" +
            "              control={<Radio />}\n" +
            "              label=\"{Label}\"\n" +
            "            />\n" +
            "            <FormControlLabel\n" +
            "              value=\"worst\"\n" +
            "              control={<Radio />}\n" +
            "              label=\"{Label}\"\n" +
            "            />\n" +
            "          </RadioGroup>\n" +
            "          <FormHelperText>Helper Text</FormHelperText>\n" +
            "        </FormControl>\n" +
            "\n\n" +
            "        <FormControl disabled variant=\"standard\">\n" +
            "          <FormLabel>label</FormLabel>\n" +
            "          <RadioGroup\n" +
            "            name=\"quiz\"\n" +
            "            value={\"\"}\n" +
            "          >\n" +
            "            <FormControlLabel\n" +
            "              value=\"best\"\n" +
            "              control={<Radio />}\n" +
            "              label=\"{Label}\"\n" +
            "            />\n" +
            "            <FormControlLabel\n" +
            "              value=\"worst\"\n" +
            "              control={<Radio />}\n" +
            "              label=\"{Label}\"\n" +
            "            />\n" +
            "          </RadioGroup>\n" +
            "          <FormHelperText>Helper Text</FormHelperText>\n" +
            "        </FormControl>"}
      >
        <FormControl error={true} variant="standard">
          <FormLabel>label</FormLabel>
          <RadioGroup
            name="quiz"
            value={""}
          >
            <FormControlLabel
              value="best"
              control={<Radio />}
              label="{Label}"
            />
            <FormControlLabel
              value="worst"
              control={<Radio />}
              label="{Label}"
            />
          </RadioGroup>
          <FormHelperText>Helper Text</FormHelperText>
        </FormControl>

        <FormControl disabled variant="standard">
          <FormLabel>label</FormLabel>
          <RadioGroup
            name="quiz"
            value={""}
          >
            <FormControlLabel
              value="best"
              control={<Radio />}
              label="{Label}"
            />
            <FormControlLabel
              value="worst"
              control={<Radio />}
              label="{Label}"
            />
          </RadioGroup>
          <FormHelperText>Helper Text</FormHelperText>
        </FormControl>
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicRadioColorLabel;
